import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import {
  FaUserCheck,
  FaTable,
  FaCalendarAlt,
  FaUserClock,
  FaUsers,
  FaFileInvoiceDollar,
} from "react-icons/fa";

import PositionMatrix from "../users/UserPositionMatrix";
import InterviewTracker from "../users/UserALlInterviews";
import ClosureReport from "../users/UserClosureReport";
import RecruiterReport from "../users/UserRecruiterReport";
import AllJoining from "../users/UserAllJoining";
import CandidateReport from "../users/CandidateReport";

export default function MyReports() {
  const user = useSelector((state) => state.user);
  const location = useLocation();

  const allowedUserIdsForClosureReport = [
    59, 26, 36, 19, 22, 16, 39, 63, 48, 54, 5, 77, 21, 44, 69, 27, 23, 54, 133, 130,
  ];

  const tabsConfig = [
    { label: "Recruiter Report", icon: FaUserCheck },
    { label: "Position Matrix", icon: FaTable },
    { label: "Interview Tracker", icon: FaCalendarAlt },
    { label: "Joining Tracker", icon: FaUserClock },
    { label: "Candidate Reports", icon: FaUsers },
    ...(user && allowedUserIdsForClosureReport.includes(user.id)
      ? [{ label: "Closure Sheet", icon: FaFileInvoiceDollar }]
      : []),
  ];

  const tabMap = {
    recruiter: 0,
    matrix: 1,
    interview: 2,
    placementtracker: 3,
    candidate: 4,
    closure: 5,
  };

  const params = new URLSearchParams(location.search);
  const queryTab = params.get("tab");

  const [tabValue, setTabValue] = useState(0);

  useEffect(() => {
    if (queryTab && tabMap[queryTab] !== undefined) {
      setTabValue(tabMap[queryTab]);
    }
  }, [queryTab]);

  return (
    <div className="w-full px-2 md:px-4 pt-1 pb-5 space-y-3 min-h-screen">
      {/* CAPSULE TABS BAR */}
      <div className="flex items-center overflow-x-auto gap-1.5 bg-slate-800/60 p-1.5 rounded-2xl no-scrollbar max-w-max">
        {tabsConfig.map((item, index) => {
          const active = tabValue === index;
          const Icon = item.icon;
          return (
            <button
              key={index}
              onClick={() => setTabValue(index)}
              className={`
                flex items-center gap-2 px-4 py-2.5 
                text-[11px] font-extrabold whitespace-nowrap rounded-xl 
                transition-all duration-200 uppercase tracking-wider cursor-pointer
                ${
                  active
                    ? "bg-indigo-600 text-white shadow-md scale-[1.01]"
                    : "text-gray-400 hover:text-white hover:bg-slate-700/50"
                }
              `}
            >
              <Icon className={`text-xs ${active ? "text-white" : "text-gray-400"}`} />
              {item.label}
            </button>
          );
        })}
      </div>

      {/* REPORT TABLE AREA CARD */}
      <div className="bg-white dark:bg-slate-900 rounded-3xl p-4 md:p-5 shadow-lg overflow-visible min-h-[650px] pb-32 transition-all duration-300">
        {tabValue === 0 && <RecruiterReport />}
        {tabValue === 1 && <PositionMatrix />}
        {tabValue === 2 && <InterviewTracker />}
        {tabValue === 3 && <AllJoining />}
        {tabValue === 4 && <CandidateReport />}
        {tabValue === 5 && <ClosureReport />}
      </div>
    </div>
  );
}